// HeaderInstallButton.js - Debug version
import React, { useState, useEffect } from 'react';
import { showInstallPrompt, isStandalone } from './pwaUtils';

function HeaderInstallButton({ lang }) {
  const [canInstall, setCanInstall] = useState(false);
  const [isInstalled, setIsInstalled] = useState(isStandalone());

  console.log('[HeaderInstallButton] Rendered with:', { canInstall, isInstalled, lang });

  useEffect(() => {
    console.log('[HeaderInstallButton] Component mounted');
    
    const handleInstallAvailable = () => {
      console.log('[HeaderInstallButton] Install available event received');
      setCanInstall(true);
    };
    
    const handleInstalled = () => {
      console.log('[HeaderInstallButton] App installed event received');
      setIsInstalled(true);
      setCanInstall(false);
    };

    window.addEventListener('pwa-install-available', handleInstallAvailable);
    window.addEventListener('pwa-installed', handleInstalled);

    return () => {
      console.log('[HeaderInstallButton] Component unmounted');
      window.removeEventListener('pwa-install-available', handleInstallAvailable);
      window.removeEventListener('pwa-installed', handleInstalled);
    };
  }, []);

  console.log('[HeaderInstallButton] Render decision:', { 
    isInstalled, 
    canInstall, 
    willShow: isInstalled || canInstall 
  });

  // Show installed state
  if (isInstalled) {
    console.log('[HeaderInstallButton] Showing INSTALLED state');
    return (
      <div
        title={lang === 1 ? 'App Instalada' : 'App Installed'}
        style={{
          width: '48px',
          height: '48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(16, 185, 129, 0.2)',
          border: '2px solid rgba(16, 185, 129, 0.4)',
          borderRadius: '12px',
          fontSize: '20px',
          color: '#10b981'
        }}
      >
        ✓
      </div>
    );
  }

  // Show install button
  if (canInstall) {
    console.log('[HeaderInstallButton] Showing INSTALL BUTTON');
    return (
      <button
        onClick={async () => {
          console.log('[HeaderInstallButton] Install button clicked');
          await showInstallPrompt();
        }}
        className="header-icon-btn"
        title={lang === 1 ? 'Instalar App' : 'Install App'}
        style={{
          width: '48px',
          height: '48px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(255, 255, 255, 0.15)',
          border: '2px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '12px',
          cursor: 'pointer',
          fontSize: '20px',
          transition: 'all 0.2s ease',
          color: 'white'
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.25)';
          e.target.style.transform = 'scale(1.05)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255, 255, 255, 0.15)';
          e.target.style.transform = 'scale(1)';
        }}
      >
        📱
      </button>
    );
  }

  console.log('[HeaderInstallButton] Not showing (neither installed nor installable)');
  return null;
}

export default HeaderInstallButton;